'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCouriersIfNeeded = exports.failureCouriers = exports.receiveCouriers = exports.requestCouriers = exports.invalidateCouriers = exports.filterCouriers = exports.INVALIDATE_COURIERS = exports.FILTER_COURIERS = exports.FAILURE_COURIERS = exports.RECEIVE_COURIERS = exports.REQUEST_COURIERS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 快递公司 Actions
                                                                                                                                                                                                                                                                   */


var _api = require('../api');

var REQUEST_COURIERS = exports.REQUEST_COURIERS = 'REQUEST_COURIERS';
var RECEIVE_COURIERS = exports.RECEIVE_COURIERS = 'RECEIVE_COURIERS';
var FAILURE_COURIERS = exports.FAILURE_COURIERS = 'FAILURE_COURIERS';
var FILTER_COURIERS = exports.FILTER_COURIERS = 'FILTER_COURIERS';
var INVALIDATE_COURIERS = exports.INVALIDATE_COURIERS = 'INVALIDATE_COURIERS';

var filterCouriers = exports.filterCouriers = function filterCouriers(filter) {
    return {
        type: FILTER_COURIERS,
        filter: filter
    };
};

var invalidateCouriers = exports.invalidateCouriers = function invalidateCouriers(filter) {
    return {
        type: INVALIDATE_COURIERS,
        filter: filter
    };
};

var requestCouriers = exports.requestCouriers = function requestCouriers(filter) {
    return {
        type: REQUEST_COURIERS,
        filter: filter
    };
};

var receiveCouriers = exports.receiveCouriers = function receiveCouriers(filter, response) {
    var data = response.data.map(function (x) {
        return _extends({}, x, {
            id: x.express_carrier_id
        });
    });
    return {
        type: RECEIVE_COURIERS,
        filter: filter,
        couriers: data
    };
};
var failureCouriers = exports.failureCouriers = function failureCouriers(error) {
    return {
        type: FAILURE_COURIERS,
        error: error
    };
};

var shouldFetchCouriers = function shouldFetchCouriers(state, filter) {
    var couriers = state.courier.couriers;
    if (couriers.items.length === 0) {
        return true;
    }
    if (couriers.isFetching) {
        return false;
    }
    return true;
};

var fetchCouriersIfNeeded = exports.fetchCouriersIfNeeded = function fetchCouriersIfNeeded() {
    var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        if (shouldFetchCouriers(getState(), filter)) {
            return dispatch(function (dispatch) {
                dispatch(requestCouriers(filter));
                return (0, _api.fetchCouriers)(filter).then(function (response) {
                    return dispatch(receiveCouriers(filter, response.data));
                }).catch(function (error) {
                    return dispatch(failureCouriers(error));
                });
            });
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/courier.js
// module id = 906
// module chunks = 0